import { z } from 'zod'

// Zod's JIT parser probes `new Function`. The admin CSP blocks eval and still
// reports the caught probe. Import this module before any module that builds a schema.
export function configureZod(): void {
    z.config({ jitless: true })
}

if (typeof window !== 'undefined') {
    configureZod()
}
